import { useEffect } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';

import NavLinks from '../NavLinks';

const useGroupSearch = () => {
  const navigate = useNavigate();
  const { resetSelectOrgUnitState } = useSelectOrgUnitData();

  const onAddGroupClicked = (event) => {
    event?.preventDefault();

    navigate(NavLinks.GROUP_ADD);
  };

  const onEditGroupClicked = (event, group) => {
    event?.preventDefault();

    const orgUnitId = group?.orgUnitId;
    const orgGroupId = group?.orgGroupId;
    const groupTypeName = group?.groupType;

    if (orgGroupId > 0) {
      navigate(NavLinks.GROUP_INFO, { state: { orgUnitId, orgGroupId, groupTypeName } });
    }
  };

  useEffect(() => {
    resetSelectOrgUnitState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    onAddGroupClicked,
    onEditGroupClicked
  };
};

export default useGroupSearch;